// extracted by mini-css-extract-plugin
export default {"textarea":"textarea__Textarea__Np1C0","disableResize":"disableResize__Textarea__Np1C0","shadedTextarea":"shadedTextarea__Textarea__Np1C0"};